function copyWithLegacySelection(text: string): boolean {
  const textarea = document.createElement("textarea");
  const activeElement = document.activeElement as HTMLElement | null;

  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  textarea.style.pointerEvents = "none";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, text.length);

  try {
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    textarea.remove();
    activeElement?.focus();
  }
}

export async function copyTextToClipboard(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (error) {
      if (copyWithLegacySelection(text)) return;
      throw error;
    }
  }

  if (!copyWithLegacySelection(text)) {
    throw new Error("Clipboard access is unavailable");
  }
}
